import React, { Component, ReactNode } from 'react'
import Transition from './Transition/Transition'
import Icon from './Icon'

export type NotifyType = 'info'
  | 'success'
  | 'error'
  | 'instruction'
  | 'warning'
type NotifiesConfig = Record<NotifyType, NotifyConfig>

interface NotifyConfig {
  background: string
}

interface Props {
  visible: boolean
  type?: NotifyType
  message: string
  children?: ReactNode
}

export default class Notify extends Component<Props> {
  notifies: NotifiesConfig = {
    info: { background: 'bg-blue-500' },
    success: { background: 'bg-green-500' },
    error: { background: 'bg-red-500' },
    instruction: { background: 'bg-purple-500' },
    warning: { background: 'bg-orange-600' }
  }

  get className () {
    const base = 'inline-flex text-white px-5 py-3'
    const type = this.props.type || 'info'
    const background = this.notifies[type].background
    return `${base} ${background}`
  }

  get transitionType () {
    return this.props.type === 'warning' ? 'flash' : 'fade'
  }

  render () {
    return (
      <Transition
        type={this.transitionType}
        visible={this.props.visible}>
        <div className="flex justify-center absolute inset-x-0 bottom-0 md:bottom-10 z-50">
          <div className={this.className}>
            <Icon
              className="mr-2"
              name="error-warning"
              size="small"
              color="white" />
            <p>{this.props.message}</p>
            {this.props.children}
          </div>
        </div>
      </Transition>
    )
  }
}
